import { get, post, serialize } from '../httpClient';

export const subscriptionsAPI = {
  createFreeSubscription: body => post('/api/subscriptions/listing/create-free', serialize(body)),
  deleteSubscription: body => post('/api/subscriptions/listing/delete', serialize(body)),
};